import React from "react"
import {
  BackgroundLink,
  Caret,
  DoubleMenu,
  DropdownEntry,
  NavbarDropdownColumn,
  NavbarDropdownMenu,
  NavbarLinkText,
  NavbarLinkWrapper,
  NavbarSpacer,
  NavbarVerticalContainer,
  NavbarVerticalLine,
} from "./styles"
import { ReactComponent as Chevron } from "@images/chevron.svg"
import Grid from "@components/elements/grid"
import Flex from "@components/elements/flex"
import PropTypes from "prop-types"
import { useResourcesMenu } from "@hooks/use-resources-menu"
import Span from "@components/elements/span"

const ResourcesList = ({ mobile }) => {
  return (
    <Flex gap="2rem">
      <DoubleMenu
        fullWidth={mobile}
        name="Articles"
        link={"/resources/articles"}
        links={[
          {
            link: "/resources/articles/what-is-a-key-performance-indicator",
            name: "What are KPIs?",
          },
          {
            link: "/resources/articles/dashboards",
            name: "What are Dashboards?",
          },
          {
            link: "/resources/articles/what-are-business-metrics",
            name: "Business Metrics",
          },
        ]}
      />

      <DoubleMenu
        fullWidth={mobile}
        name="Dashboard Examples"
        link={"/resources/dashboard-examples"}
        links={[
          {
            link: "/resources/dashboard-examples/executive/financial-performance",
            name: "Finance",
          },
          {
            link: "/resources/dashboard-examples/executive",
            name: "Executive",
          },
          {
            link: "/resources/dashboard-examples/sales",
            name: "Sales",
          },
          {
            link: "/resources/dashboard-examples/saas",
            name: "SaaS",
          },
          {
            link: "/resources/dashboard-examples/marketing",
            name: "Marketing",
          },
          {
            link: "/resources/dashboard-examples/social-media",
            name: "Social Media",
          },
        ]}
      />

      <DoubleMenu
        fullWidth={mobile}
        name="KPI Examples"
        link={"/resources/kpi-examples"}
        links={[
          {
            link: "/resources/kpi-examples/marketing",
            name: "Marketing",
          },
          {
            link: "/resources/kpi-examples/social-media",
            name: "Social Media",
          },
          {
            link: "/resources/kpi-examples/sales",
            name: "Sales",
          },
          {
            link: "/resources/kpi-examples/saas",
            name: "SaaS",
          },
          {
            link: "/resources/kpi-examples/saas",
            name: "SaaS",
          },
          {
            link: "/resources/kpi-examples/social-media/facebook-engagement-metrics",
            name: "Facebook Engagement",
          },
        ]}
      />
    </Flex>
  )
}

ResourcesList.propTypes = {
  mobile: PropTypes.bool,
}

const ResourcesGrid = () => {
  const { logos, blog, podcast } = useResourcesMenu()
  return (
    <>
      <BackgroundLink
        name={"MetricHQ"}
        link={"https://www.metrichq.org/"}
        icon={logos["b9c999df-d4dd-47d8-b0f1-63a0f7391b53"]}
        description={
          <p>
            Find industry-standard metric definitions and choose from hundreds
            of pre-built metrics.
          </p>
        }
        newTab
      />

      <BackgroundLink
        name="Klipfolio Blog"
        link={"/blog"}
        icon={logos["07a99c63-10ab-4a46-b377-6fdb54bc1ef7"]}
        links={blog}
      />

    </>
  )
}

const ResourcesVertical = ({ mobile }) => {
  const { logos } = useResourcesMenu()
  return (
    <NavbarVerticalContainer>
      <NavbarDropdownColumn vertical={!mobile} as="ul">
        <DropdownEntry
          name="Klips Help Center"
          title
          link="https://support.klipfolio.com/hc/en-us/categories/360001248554-Klips"
          icon={logos["18f70809-7de7-4b2a-8bc3-7316a514202d"]}
          newTab
        />
        <DropdownEntry
          name="Klipfolio Services"
          title
          link="/services"
          icon={logos["8c0e0ded-54b0-4afb-816c-540a5b4f92f0"]}
          newTab
        />
        <DropdownEntry
          name="Contact Us"
          title
          link="/about/contact-us"
          icon={logos["0dc294aa-1921-46cb-8b6e-fc277eba9419"]}
        />
      </NavbarDropdownColumn>
    </NavbarVerticalContainer>
  )
}

ResourcesVertical.propTypes = {
  mobile: PropTypes.bool,
}

export const DesktopResourcesMenu = React.memo(({ caretTranslate }) => {
  return (
    <NavbarLinkWrapper>
      <NavbarLinkText
        hasDropdown
        title={"Resources"}
        as={"a"}
        href={"/resources"}
      >
        Resources&nbsp;
        <Chevron width={9} height={7} />
        <Caret style={{ bottom: caretTranslate }} />
      </NavbarLinkText>
      <NavbarDropdownMenu>
        <Grid columns="repeat(3, auto)">
          <Grid columns="1fr" gap="1rem">
            <ResourcesGrid />
          </Grid>
          <NavbarSpacer />
          <ResourcesList />
          <NavbarVerticalLine style={{ margin: "2rem 0 1rem" }} />
          <ResourcesVertical />
        </Grid>
      </NavbarDropdownMenu>
    </NavbarLinkWrapper>
  )
})

DesktopResourcesMenu.displayName = "DesktopResourcesMenu"

export const MobileResourcesMenu = React.memo(() => {
  return (
    <NavbarLinkWrapper id={`menu-resources`}>
      <Span color="#333" fontWeight={700}>
        Resources
      </Span>
      <Flex margin="1rem 0 0" gap="2rem">
        <Flex gap="1rem">
          <ResourcesGrid mobile />
        </Flex>
        <ResourcesList mobile />
        <ResourcesVertical mobile />
      </Flex>
    </NavbarLinkWrapper>
  )
})

MobileResourcesMenu.displayName = "MobileResourcesMenu"
